<script lang="ts">
	import { getTranslate } from "@utils/getTranslate.js";
	import { getHowItWorksAnchor } from "@core/schema/paths/getHowItWorksAnchor.js";
	import { idFromAnchor } from "@core/schema/utils/idFromAnchor.js";
	import { getGlobalTemplateProps } from "../../contexts/getGlobalTemplateProps.js";
	import translations from "./FathersClubHowItWorksSection.translations.json" with { type: "json" };
	import HowItWorksSection from "./HowItWorksSection.svelte";

	const { tenant } = getGlobalTemplateProps();
	const translate = getTranslate(translations);
	const id = idFromAnchor(getHowItWorksAnchor(tenant.locale));
</script>

<HowItWorksSection
	{id}
	section={translate("section")}
	title={translate("title")}
	footer={translate("membership")}
	steps={[
		{
			title: translate("stepOneTitle"),
			description: translate("stepOneDescription"),
			class: "bg-fcramber container-start-1 md:container-end-6 lg:container-end-4",
		},
		{
			title: translate("stepTwoTitle"),
			description: translate("stepTwoDescription"),
			class: ["bg-fcrtan", "md:container-start-7 lg:container-start-5 lg:container-end-8"],
		},
		{
			title: translate("stepThreeTitle"),
			description: translate("stepThreeDescription"),
			class: "bg-fcrslate md:container-6 lg:container-start-9 lg:container-end-12",
		},
	]}
/>
